import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import down_icn from "../../assets/images/down_icn.png";
import library_tower from "../../assets/images/library_tower.png";

import back_arrow from "../../assets/images/back_arrow.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Spinner } from "react-bootstrap";
import BackSecion from "../common/header";
import { getLocalStorage } from "../../core/localStorageService";
import { PayloadProps } from "../../core/schema";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";
import { useNavigate } from "react-router";

import moment from "moment";

var sectionStyle = {
  backgroundImage: `url(${down_icn})`,
};

/**
 * Renders Component.
 * @return {LibraryBooks} renders Component.
 */
export default function LibraryBooks() {
  const navigate = useNavigate();

    const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(() => {
    if(selectedTab === 0){
        getMyBooks();
    }else{
        getAllBooks();
    }
  }, [selectedTab]);

  const getMyBooks = () => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id
      },
      method: "POST",
      apiUrl: apiEndpoint.myLibraryBooks,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data) {
          setData(res.data);
        }
        console.log(res.data)
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getAllBooks = () => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id
      },
      method: "POST",
      apiUrl: apiEndpoint.libraryBooksData,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data) {
          setData(res.data);
        }
        console.log(res.data.title)

      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const reserveBook = (id:number) => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        user_id: user?.student[0]?.user_id,
        id:id
      },
      method: "POST",
      apiUrl: apiEndpoint.reserveBook,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data) {
          
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        getAllBooks()
      });
  };

  return (
    <>
      <div className="cmmn px-3">
        <Container>
          <BackSecion name="Library" navigate_action="/home" />
          
          <Row className="mt-4 p-075 pr-075">
            <Col
              xs={5}
              className={`d-flex flex-column align-items-center f-14 fw-bold text-center ${selectedTab === 0 ? 'blue_clr': ''}`}
              onClick={() => setSelectedTab(0)}
            >
              <span role="button" className="fw-bolder pb-1">
                My Books
              </span>
            </Col>
            <Col xs={6} className={`f-14 d-flex flex-column align-items-center  ${selectedTab === 1 ? 'blue_clr': ''}`}
            onClick={() => setSelectedTab(1)}
            >
              <span role="button" className="text-decoration-none status_clr fw-bold link_style">
                All Books
              </span>
            </Col>
          </Row>
          {isLoading && (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {!isLoading && selectedTab === 0 &&
            data.length >0 &&
            data.map((item: any, i: number) => {
              return (
          <Row className="mt-3" key={i}>
            <Col xs={2} sm={1} className="p-0">
              <img src={library_tower} alt="" width="60px" height="78px" />
            </Col>
            <Col xs={7}>
              <p className="fw-bold f-13 m-0">{item.title}</p>
              <p className="f-12 status_clr mb-2">
                {item.author} • {moment(item.created_date).format("DD MMM YYYY")}
              </p>
              {/* <p className="f-12 status_clr m-0">To be returned on</p>
              <p className="nt_paid_clr f-12 m-0">22 Sep 20</p> */}
            </Col>
          </Row>
          
          );
        })}
          {!isLoading && selectedTab === 1 &&
            data.length>0 &&
            data.map((item: any, i: number) => {
              return (
          <Row className="mt-3" key={i}>
            <Col xs={2} sm={1} className="p-0">
              <img src={library_tower} alt="" width="60px" height="78px" />
            </Col>
            <Col xs={7}>
              <p className="fw-bold f-13 m-0">{item.title}</p>
              <p className="f-12 status_clr mb-2">
                {item.author} • {moment(item.created_date).format("DD MMM YYYY")}
              </p>
              {/* <p className="f-12 status_clr m-0">To be returned on</p>
              <p className="nt_paid_clr f-12 m-0">22 Sep 20</p> */}
              <p className="blue_clr f-12 m-0 cursor" onClick={() => reserveBook(item.id)}>Reserve</p>
            </Col>
          </Row>
          );
        })}
        {!isLoading && data.length === 0 && <Row className="mt-3" >
        <Col xs={12} className="text-center">No books found.</Col>
          </Row>}
        </Container>
      </div>
    </>
  );
}
